import { EventAggregator } from "aurelia-event-aggregator";
import { I18N_EA_SIGNAL } from "./app";

export abstract class BasePage {
	private eventAggregator: EventAggregator;
	protected updateTranslationsSubscriber: any;
	constructor(eventAggregator: EventAggregator) {
		this.eventAggregator = eventAggregator;
        this.updateTranslationsSubscriber = this.eventAggregator.subscribe(I18N_EA_SIGNAL, () => {
			this.loadTranslations();
		});
	}
	public loadTranslations() { }

	attached() {
		this.loadTranslations();
	}
}